import React, { useMemo } from "react";
import { HeaderGroup } from "react-table";
import { Select, SimpleGrid, Text } from "@chakra-ui/react";
import { SelectOption } from "./SelectOption";

interface Props {
  column: HeaderGroup;
  options: SelectOption[];
}

const LazySelectFilter: React.FC<Props> =
  ({ column: { filterValue, setFilter, preFilteredRows, id, render },
    options }: Props) => {
        return (<SimpleGrid>
      <Text>{render("Header")}</Text>
      <Select
        value={filterValue || ""}
        onChange={e => setFilter(e.target.value || undefined)}
        size="sm"
      >
        <option value="">All</option>
        {options.map((option, i) => (
          <option key={i} value={option.id}>
            {option.displayValue}
          </option>
        ))}
      </Select>
    </SimpleGrid>)
    }

export default LazySelectFilter;
